function getDefault() {
  return {
    id: null,
    title: '',
    description: '',
    date: new Date(),
    endDate: null,
    frequency: '',
    type: null,
  };
}

function makeRule(data) {
  if (data === undefined) {
    return getDefault();
  }

  const processedData = {
    date: new Date(data.date),
    endDate: data.endDate ? new Date(data.endDate) : null,
    type: data.type,
    frequency: data.frequency,
  };

  return { ...data, ...processedData };
}

/**
 [Vue migration] Developer Note
 This component has a twin version for both Vue 2 and Vue 3 projects.
 When making changes, remember to update and test both versions.
 */
export default makeRule;
